import { C, fonts } from "../theme.js";
import { SectionLabel } from "./primitives.jsx";
import { PAIN } from "../content.js";

const PainIcon = ({ kind, accent }) => {
  if (kind === "stall")
    return (
      <svg width="34" height="34" viewBox="0 0 34 34" fill="none" stroke={accent} strokeWidth="1.4">
        <circle cx="17" cy="17" r="13" />
        <path d="M17 9v8l5 3" />
        <path d="M5 5l24 24" stroke={accent} strokeOpacity="0.5" strokeDasharray="2 3" />
      </svg>
    );
  if (kind === "team")
    return (
      <svg width="34" height="34" viewBox="0 0 34 34" fill="none" stroke={accent} strokeWidth="1.4">
        <circle cx="12" cy="13" r="4" />
        <circle cx="23" cy="13" r="4" />
        <path d="M5 27c0-4 3-7 7-7s7 3 7 7" />
        <path d="M19 27c0-3 2-6 5-6" strokeDasharray="2 2" />
      </svg>
    );
  return (
    <svg width="34" height="34" viewBox="0 0 34 34" fill="none" stroke={accent} strokeWidth="1.4">
      <path d="M17 4l4 8 8 1-6 6 2 9-8-5-8 5 2-9-6-6 8-1z" />
    </svg>
  );
};

export const Pain = ({ accent }) => (
  <section id="challenges" style={{ background: C.bg, padding: "140px 40px" }}>
    <div style={{ maxWidth: 1280, margin: "0 auto" }}>
      <div
        style={{
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: 24,
          marginBottom: 56,
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          <SectionLabel accent={accent}>// CHALLENGES</SectionLabel>
          <h2
            style={{
              margin: 0,
              fontFamily: fonts.serif,
              fontSize: "clamp(36px, 4.4vw, 56px)",
              fontWeight: 500,
              color: C.fg,
              letterSpacing: "-0.01em",
              lineHeight: 1.05,
            }}
          >
            Where AI projects{" "}
            <em style={{ color: accent, fontStyle: "italic", fontWeight: 500 }}>get stuck.</em>
          </h2>
        </div>
        <p
          style={{
            margin: 0,
            fontFamily: fonts.mono,
            fontSize: 13,
            color: C.body,
            maxWidth: 360,
            lineHeight: 1.65,
          }}
        >
          Three recurring patterns we see when companies bring us in.
        </p>
      </div>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
          gap: 20,
        }}
      >
        {PAIN.map((p, i) => (
          <div
            key={i}
            style={{
              position: "relative",
              padding: "32px 28px",
              background: C.card,
              border: `1px solid ${C.border}`,
              borderRadius: 8,
              display: "flex",
              flexDirection: "column",
              gap: 16,
              minHeight: 240,
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
              <PainIcon kind={p.icon} accent={accent} />
              <span style={{ fontFamily: fonts.mono, fontSize: 11, color: C.faint, letterSpacing: "0.16em" }}>
                ×0{i + 1}
              </span>
            </div>
            <h3
              style={{
                margin: 0,
                fontFamily: fonts.serif,
                fontSize: 26,
                fontWeight: 500,
                color: C.fg,
                lineHeight: 1.15,
              }}
            >
              {p.t}
            </h3>
            <p style={{ margin: 0, fontFamily: fonts.sans, fontSize: 14, lineHeight: 1.65, color: C.body }}>
              {p.b}
            </p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
